import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'
import { MinimalButton } from '@calendly/ui/components/minimal-button'
import { BodyText } from '@calendly/ui/components/typography'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'

import { buildCalendlyMarketingHref, CALENDLY_MARKETING_BASE_PATH } from 'utils/calendly_marketing_url'
import { BrandLogo } from 'components/layout/brand_logo'
import { useI18n } from 'locales'
import { isEmbeddedSelector } from 'selectors/embed'
import _GridRow from "booking_redesign_legal_footer-GridRow.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=GridRow";
import _LogoLink from "booking_redesign_legal_footer-LogoLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=LogoLink";
import _RightLinks from "booking_redesign_legal_footer-RightLinks.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=RightLinks";
import _CookieButton from "booking_redesign_legal_footer-CookieButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/booking_redesign_legal_footer.js?styleId=CookieButton";


const checkIfIframe = () => window.location !== window.parent.location

const GridRow = /*#__PURE__*/styled('div', null, {
  displayName: "GridRow",
  styles: _GridRow
})

const LogoLink = /*#__PURE__*/styled(Link, null, {
  displayName: "LogoLink",
  styles: _LogoLink
})

const RightLinks = /*#__PURE__*/styled('div', null, {
  displayName: "RightLinks",
  styles: _RightLinks
})

const CookieButton = /*#__PURE__*/styled(MinimalButton, null, {
  displayName: "CookieButton",
  styles: _CookieButton
})

export const BookingRedesignLegalFooter = ({ className }) => {
  const { i18n } = useI18n()
  const embedFromStore = useSelector(isEmbeddedSelector)
  const isEmbedded = checkIfIframe() || embedFromStore
  const logoHref = buildCalendlyMarketingHref(CALENDLY_MARKETING_BASE_PATH)

  return (
    <GridRow className={className}>
      <LogoLink
        underline={false}
        href={logoHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        <BrandLogo />
      </LogoLink>
      <RightLinks>
        <CookieButton onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
          <BodyText as="span" inline size="medium" color={primaryColor}>
            {i18n.t('booking.terms_and_conditions.manage_cookies')}
          </BodyText>
        </CookieButton>
        {!isEmbedded && (
          <Link
            underline={false}
            href="https://calendly.com/legal/privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BodyText as="span" inline size="medium" color={primaryColor}>
              {i18n.t('booking.terms_and_conditions.privacy_policy')}
            </BodyText>
          </Link>
        )}
      </RightLinks>
    </GridRow>
  )
}
